import type { ReactNode } from 'react';
import { cn } from '../../lib/utils.ts';

/**
 * Every page's title block (TS-1591): an optional back link above, the title and a one-line
 * description on the left, the page's actions on the right. Actions wrap under the title on a
 * narrow screen instead of pushing it off the edge.
 */
export function PageHeader({
  title,
  description,
  actions,
  eyebrow,
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  /** A small line above the title: a back link, a record type. */
  eyebrow?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('mb-8 flex flex-wrap items-end justify-between gap-x-8 gap-y-4', className)}>
      <div className="min-w-0 flex-1 basis-72">
        {eyebrow && <div className="mb-3">{eyebrow}</div>}
        <h2 className="truncate text-[28px] leading-tight font-bold tracking-tight">{title}</h2>
        {description && (
          <div className="text-muted-foreground mt-2 max-w-3xl text-[15px] leading-relaxed">
            {description}
          </div>
        )}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
